import { Loader2, RefreshCw } from "lucide-react"
import type { ReactNode } from "react"
import { Button } from "@/components/ui/primitives"
import { useTranslation } from "@/hooks/use-translation"

/** Состояние ленивой загрузки узла Библиотеки (паттерн AsyncSlot из пикера кадров). */
export type LibrarySlot<T> = { status: "loading" } | { status: "error" } | { status: "ready"; data: T }

export function LibraryNodeLoading() {
  return (
    <div className="flex items-center justify-center py-10">
      <Loader2 className="h-5 w-5 animate-spin text-ui-text-muted" />
    </div>
  )
}

export function LibraryNodeError({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation(["workspace"])
  return (
    <div className="flex flex-col items-center gap-3 py-10 text-center">
      <p className="text-sm text-ui-status-failed">{t("library.loadFailed")}</p>
      <Button type="button" size="sm" variant="outline" onClick={onRetry}>
        <RefreshCw className="h-4 w-4" />
        {t("library.retry")}
      </Button>
    </div>
  )
}

export function LibraryNodeEmpty({ children }: { children: ReactNode }) {
  return <p className="py-10 text-center text-sm text-ui-text-muted">{children}</p>
}
